import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { BsDatepickerViewMode } from "ngx-bootstrap/datepicker/models";
import { Observable, of } from "rxjs";
import { REMOVESPACESONLY } from "src/app/helpers/helperResources";
import { GeneralService } from "src/app/services/general.service";
declare var $: any;

@Component({
  selector: "app-data-filter",
  templateUrl: "./data-filter.component.html",
  styleUrls: ["./data-filter.component.css"],
})
export class DataFilterComponent implements OnInit {
  @Input() accordions;
  @Input() dataSource;
  @Input() formControls;
  @Input() customFilters;
  @Input() !customConfig;
  @Input() filterPayload;
  @Input() dataChanged: Observable<any>;
  @Output() filteredSource: EventEmitter<any> = new EventEmitter<any>(null);

  customFilterForm: FormGroup;
  customFilterFormCreate: FormGroup;
  minMode: BsDatepickerViewMode = "month";
  config  = {
    search: true, // true/false for the search functionality defaults to false,
    placeholder: "Select ", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    noResultsFound: "Type here to search", // text to be displayed when no items are found while searching
    searchPlaceholder: "search",
  };
  bsConfig: Partial<BsDatepickerConfig> = { adaptivePosition: true };
  subs = [];
  btn: any = {};
  data: any = {
    filterTypeBox: [],
    arrayFilterSource: [],
    arrayCompany: [],
  };
  filterCheckBox = {};
  filterRadioBox = {};
  filterSelectBox: any = {
    gender: null,
    maritalStatus: null,
  };
  filterRange = {};
  loader: any = {};
  filter: any = {
    search: [],
    minrange: [],
    maxrange: [],
    checkBox: {},
    status: true,
    current: {},
    selectBox: {},
  };
  filterValue: string;
  openedIndex: number | null = null;
  openedEditIndex: number | null = null;

  constructor(private gs: GeneralService, private fb: FormBuilder) {
    this.btn.disabled = true;
    this.btn.create = "Create Filter";
  }

  ngOnInit() {
    if(this.customConfig && Object.keys(this.customConfig)){
      this.config = this.customConfig;
    }
    if (this.dataChanged) {
      this.subs.push(
        this.dataChanged.subscribe((changed) => {
          if (changed) {
            setTimeout(() => {
              this.filter.source = this.dataSource;

              this.customFilters = this.customFilters;

              // this.data.filterTypeBox = this.filterByType("box");
              this.data.filterTypeBox = this.filterByType("select");
              this.filterSource(this.data.filterTypeBox);
            }, 1000);
          }
        })
      );
    }

    // Init Forms
    this.ngForms();
    this.ngForm();
  }

  ngForms() {
    if (this.formControls === null) return;

    let group: any = {};
    group["filterName"] = new FormControl(null, [
      Validators.required,
      REMOVESPACESONLY,
    ]);
    this.formControls.forEach((ctrl) => {
      if (ctrl.type === "label-head") return;
      group[ctrl.name] = new FormControl(null);
    });
    this.customFilterForm = new FormGroup(group);
  }

  ngForm() {
    if (this.formControls === null) return;

    let group: any = {};
    group["filterName"] = new FormControl(null, [
      Validators.required,
      REMOVESPACESONLY,
    ]);
    this.formControls.forEach((ctrl) => {
      if (ctrl.type === "label-head") return;
      group[ctrl.name] = new FormControl(null);
    });
    this.customFilterFormCreate = new FormGroup(group);
  }

  onInputChanges() {
    if (
      Object.keys(this.filterCheckBox).length > 0 ||
      Object.keys(this.filterRange).length > 0 ||
      Object.keys(this.filterRadioBox).length > 0
    ) {
      this.btn.disabled = false;
    }
  }

  onSelectBoxLookUp(value, accordion) {
    if (!value) return;

    let result;
    this.config.noResultsFound = "No results found!";
    // this.accordions =
    this.accordions.filter((item) => {
      if (item.name === accordion["name"]) {
        result = accordion["data"] = item.data.filter((data) => data === value);
      }
    });
  }

  updateNoResultText() {
    const el = document.querySelector(
      ".ngx-dropdown-container .ngx-dropdown-list-container ul li:last-child"
    );
    el.textContent = "No results found!";
  }

  // Get all filter.type = 'type'
  // from this.accordions
  filterByType(type: string) {
    let res;
    if (type === undefined) return;
    if (type === "box") res = this.accordions.filter((f) => f.type === type);
    if (type === "select") res = this.accordions.filter((f) => f.type === type);
    else if (type === "range")
      res = this.accordions.filter((f) => f.type === type);
    return res;
  }

  // Filter dataSource by
  // filter.filterKey = 'filterKey' from this.accordions
  filterSource(arrayFilterSource: any) {
    if (this.dataSource === undefined) return;

    arrayFilterSource.filter((f) => {
      let filterKey = f.filterKey;

      // Manipulate SalesPerson Data
       if (filterKey.toLowerCase() === "ownername") {
        this.data.arrayFilterSource[filterKey] = this.accordions[0].data;
        return;
      }

      else if (filterKey.toLowerCase() === "gender") {
        this.data.arrayFilterSource[filterKey] = this.accordions[2].data;
        return;
      }

      else if (filterKey.toLowerCase() === "maritalstatus") {
        this.data.arrayFilterSource[filterKey] = this.accordions[3].data;
        return;
      }

      // Manipulate Industry Data
      else if (filterKey.toLowerCase() === "industry") {
        this.data.arrayFilterSource[filterKey] = this.accordions[2].data;
        return;
      }

      // Manipulate Compaby Data
      // else if (filterKey.toLowerCase() === "ownerName") {
      //   this.data.arrayFilterSource[filterKey] = this.filterPayload[filterKey];
      //   return;
      // }

      // Default Data
      else {
        this.data.arrayFilterSource[filterKey] = this.dataSource.map(
          (item) => ({
            id: item.id,
            [filterKey]: item[filterKey],
          })
        );
      }
    });
  }

  // When Filter SlectBox is selected
  onSelectBoxChange(filterKey: string) {
    let dataSource = this.filter.source; //default data source

    //if no selectbox filters use default record
    // else use filtered dataSource
    if (Object.keys(this.filterSelectBox).length > 0) {
      dataSource = this.dataSource;
    }

    this.dataSourceFilter(dataSource, filterKey);
  }

  processSelectBoxFilters(filterKey: any, arraySource: any): any {
    let filteredSource: any = [];
    let searchValue = this.filterSelectBox[filterKey];

    // Filter secondary data source
    arraySource.filter((item) => {
      if (item[filterKey] === null || item[filterKey] === undefined) return;
      if (item[filterKey].toLowerCase() === searchValue.toLowerCase()) {
        if (!filteredSource.includes(item)) filteredSource.push(item);
      }
    });
    return filteredSource;
  }

  // When Filter CheckBox is checked/unchecked
  onCheckBoxChange(filterKey: string, value: any) {
    let dataSource = this.filter.source; //default data source
    let isFound = this.isCheckboxFamily(filterKey, this.filterCheckBox);

    this.filterCheckBox[filterKey + "=" + value[filterKey]] = !this
      .filterCheckBox[filterKey + "=" + value[filterKey]];

    if (this.filterCheckBox[filterKey + "=" + value[filterKey]]) {
      this.filterCheckBox[filterKey + "=" + value[filterKey]] = true;
    } else {
      delete this.filterCheckBox[filterKey + "=" + value[filterKey]];
    }

    //if no range filters use default record
    // else use filtered dataSource
    if (Object.keys(this.filterRange).length > 0) {
      dataSource = this.dataSource;
    }

    //if filter isn't isFound
    // && dataSource has been filtered
    // use filtered dataSource (useful for the second checkbox occurrence)
    if (!isFound && this.filter.status) {
      dataSource = this.dataSource;
    }

    this.dataSourceFilter(dataSource);
  }

  //
  isCheckboxFamily(filterKey: string, arrayFilters: any): boolean {
    let filter: any = {};
    // Check if filter exist in checkbox
    if (Object.keys(arrayFilters).length > 0) {
      for (let key in arrayFilters) {
        filter.type = key.split("=")[0];
        filter[filter.type] = key.split("=")[1];
        if (filter.type === filterKey) return true;
      }
      return false;
    }
    return true;
  }

  processCheckboxFilters(arrayFilters: any, arraySource: any): any {
    let filter: any = {};
    let filteredSource: any = [];

    // Filter secondary data source
    for (let key in arrayFilters) {
      filter.type = key.split("=")[0];
      filter[filter.type] = key.split("=")[1];
      arraySource.filter((item) => {
        if (item[filter.type] === filter[filter.type]) {
          if (!filteredSource.includes(item)) filteredSource.push(item);
        }
      });
    }
    return filteredSource;
  }

  // TODO: When min > max, we need to be able to return the data-source back when another filter is initiated,

  //onChangeRange
  onChangeRange(filterKey: string) {
    let range: any = [];
    let dataSource = this.filter.source; //default data source
    let min = filterKey + "=min",
      max = filterKey + "=max";

    range[min] = parseInt(this.filter.minrange[filterKey]) || 0;
    range[max] = parseInt(this.filter.maxrange[filterKey]) || 10000;

    if (Object.keys(this.filterCheckBox).length > 0 && this.filter.status) {
      dataSource = this.dataSource;
    }

    if (this.filterRange.hasOwnProperty(min)) {
      // Delete and add again
      delete this.filterRange[min];
      delete this.filterRange[max];
      Object.assign(this.filterRange, range);
    } else {
      Object.assign(this.filterRange, range);
    }

    this.dataSourceFilter(dataSource, filterKey);
  }

  //onChangeDateRange
  onChangeDateRange(filterKey: string) {
    let range: any = [];
    let dataSource = this.filter.source; //default data source
    const min = new Date(this.filter.minrange[filterKey]).getTime();
    const max = new Date(this.filter.maxrange[filterKey]).getTime();
    this.filterValue = `range={"${filterKey}":{"from":${min},"to":${max}}}`;

    if (Object.keys(this.filterCheckBox).length > 0 && this.filter.status) {
      dataSource = this.dataSource;
    }

    if (this.filterRange.hasOwnProperty(min)) {
      // Delete and add again
      delete this.filterRange[min];
      delete this.filterRange[max];
      Object.assign(this.filterRange, range);
    } else {
      Object.assign(this.filterRange, range);
    }
    this.filterSelectBox = {}; //Clear filterSelectBox
    this.dataSourceFilter(dataSource, filterKey);
  }

  processRangeFilters(arrayFilters: any, filterKey: string, arraySource: any) {
    let min, max: any;
    let filteredSource: any = [];

    min = filterKey + "=min";
    max = filterKey + "=max";

    if (Object.keys(arrayFilters).length === 0) return;
    if (!arrayFilters.hasOwnProperty(min)) return;
    min = arrayFilters[min];
    max = arrayFilters[max];

    filteredSource = arraySource.filter((item) => {
      return item[filterKey] >= min && item[filterKey] <= max;
    });
    return filteredSource;
  }

  // Filter Data Source
  dataSourceFilter(filteredSource: any, filterKey?: string) {
    let filter: any = {};
    let dataSource = filteredSource;

    // Check if there is any filter to process for checkbox
    if (Object.keys(this.filterCheckBox).length > 0) {
      // If filter exist, process processCheckboxFilters
      dataSource = this.processCheckboxFilters(this.filterCheckBox, dataSource);
    }

    // Check if there is any filter to process for selectbox
    if (Object.keys(this.filterSelectBox).length > 0) {
      // If filter exist, process processRangeFilters
      dataSource = this.processSelectBoxFilters(filterKey, dataSource);
    }

    // Check if there is any filter to process for range
    if (filterKey !== undefined && Object.keys(this.filterRange).length > 0) {
      // If filter exist, process processRangeFilters
      for (let key in this.filterRange) {
        filter.type = key.split("=")[0];
        dataSource = this.processRangeFilters(
          this.filterRange,
          filter.type,
          dataSource
        );
      }
    }

    const data = {
      filterKey: filterKey,
      filterValue: this.filterValue
    }

    this.dataSource = dataSource;
    this.filteredSource.emit({ action: "filter", data: data });
    // Data has been filtered
    if (this.dataSource.length > 0) this.filter.status = true;
    this.onInputChanges(); //Check for input changes
  }

  //Process Custom Filter
  processCustomFilter(filter) {
    this.resetFilters(); //Clear Filters
    this.presetFilters(filter); // Preset input values
    $(".cc--filter .accordion .card .collapse").collapse("show"); //Toogle all accordions
    //select radio button or Set created filter as default
    this.filterRadioBox[filter.id] = true;
    this.filteredSource.emit({ action: "processFilter", data: filter });
    this.onInputChanges();
    this.manageButton();
  }

  // Preset each filter type with the
  // default data
  presetFilters(filter) {
    this.filter.current = filter;
    this.filter.name = filter.filterName ? filter.filterName : filter.name;
    this.accordions.filter((item) => {
      if (filter.hasOwnProperty(item.filterKey)) {
        this.filter.minrange[item.filterKey] = filter[item.filterKey];
        this.onChangeRange(item.filterKey); //process filters for update
      }
    });
  }

  // Process payload on Create Custom Filter
  onCreateCustomFilter() {
    this.loader.create = true;

    let filter: any = {};
    let arrayFilters: any = {};

    // Check if there is any filter to process for checkbox
    if (Object.keys(this.filterCheckBox).length > 0) {
      // Check if there is any filter to process for checkboxes
      for (let [key, value] of Object.entries(this.filterCheckBox)) {
        filter = {}; //Clear filter
        let type = key.split("=")[0];
        filter[type] = value;
        if (!arrayFilters.hasOwnProperty(type)) {
          Object.assign(arrayFilters, filter);
        }
      }
    }

    // Check if there is any filter to process for range
    if (Object.keys(this.filterRange).length > 0) {
      for (let [key, value] of Object.entries(this.filterRange)) {
        filter = {}; //Clear filter
        let type = key.split("=")[0];
        filter[type] = value;
        if (!arrayFilters.hasOwnProperty(type)) {
          Object.assign(arrayFilters, filter);
        }
      }
    }

    const payload = {
      ...arrayFilters,
      filterName: this.filter.filterName,
    };
    this.createCustomFilter(payload);
    setTimeout(() => (this.loader.create = false), 2000);
  }

  // Process payload on Update Custom Filter
  onUpdateCustomFilter() {
    this.loader.create = true;

    let filter: any = {};
    let arrayFilters: any = {};

    // Check if there is any filter to process for checkbox
    if (Object.keys(this.filterCheckBox).length > 0) {
      // Check if there is any filter to process for checkboxes
      for (let [key, value] of Object.entries(this.filterCheckBox)) {
        filter = {}; //Clear filter
        let type = key.split("=")[0];
        filter[type] = value;
        if (!arrayFilters.hasOwnProperty(type)) {
          Object.assign(arrayFilters, filter);
        }
      }
    }

    // Check if there is any filter to process for range
    if (Object.keys(this.filterRange).length > 0) {
      for (let [key, value] of Object.entries(this.filterRange)) {
        filter = {}; //Clear filter
        let type = key.split("=")[0];
        filter[type] = value;
        if (!arrayFilters.hasOwnProperty(type)) {
          Object.assign(arrayFilters, filter);
        }
      }
    }

    const payload = {
      ...arrayFilters,
      id: this.filter.current.id,
      filterName: this.filter.filterName,
    };
    this.updateCustomFilter(payload);
    setTimeout(() => (this.loader.create = false), 2000);
  }

  // Create Custom Filter
  createCustomFilter(payload) {
    this.filteredSource.emit({ action: "createFilter", data: payload });
    // Set created filter as default
    this.customFilters.filter((f) => {
      if (f.filterName === payload.filterName) {
        this.processCustomFilter(f);
      }
    });

    //@ts-ignore
    setTimeout(() => document.querySelector("#closeModal").click(), 1200);
  }

  // Update Custom Filter
  updateCustomFilter(payload) {
    this.filteredSource.emit({ action: "updateFilter", data: payload });
    // Set created filter as default
    this.customFilters.filter((f) => {
      if (f.filterName === payload.filterName) {
        this.processCustomFilter(f);
      }
    });

    //@ts-ignore
    setTimeout(() => document.querySelector("#closeModal").click(), 1200);
  }

  // Remove or Delete Custom Filter
  removeCustomFilter(id) {
    let name = this.getCustomFilterNameById(id);
    const title = "Delete " + name;
    this.gs.sweetAlertGeneralDelete(title, "Delete").then((res) => {
      if (res.value) {
        this.filteredSource.emit({ action: "deleteFilter", data: id });
      }
    });
  }

  // Get Custom Filter Name by filterId
  getCustomFilterNameById(id) {
    let name;
    this.customFilters.filter((f) => {
      if (f.id === id) name = f.filterName || f.name;
    });
    return name;
  }

  manageButton() {
    if (Object.keys(this.filterRadioBox).length > 0)
      this.btn.create = "Update Filter";
  }

  //Process Custom Filter List
  processCustomFilterList(filter) {
    this.resetFilters(); //Clear Filters
    // $(".cc--filter .accordion .card #collapse22").collapse("hide"); //Toogle off create accordions
    // $(".cc--filter .accordion .card .collapse").collapse("hide"); //Toogle off all accordions
    this.filteredSource.emit({ action: "processFilter", data: filter });
    this.customFilterForm.reset();
  }

  // Process payload on Create Custom Filter
  onCustomFilterCreate() {
    this.loader.create = true;

    const payload = {
      ...this.customFilterFormCreate.value,
    };
    this.filteredSource.emit({ action: "createFilter", data: payload });
    //@ts-ignore

    // setTimeout(() => (this.loader.create = false), 2000);
    setTimeout(() => {
      this.loader.create = false;
      // Close Toggle
      $(".cc--filter .accordion .card #collapse22").collapse("hide"); //Toogle off create accordions
      this.customFilterFormCreate.reset();
    }, 2000);
    // this.customFilterFormCreate.reset();
  }

  // Process payload on Update Custom Filter
  onCustomFilterEdit(data, index) {
    this.customFilterForm.reset();
    this.customFilterForm.patchValue(data.filter);

    const check = $("#collapseViewFilter" + index);
    // Close Toggle
    $("#collapsefilter" + index).collapse("show"); //Toogle off create accordions
  }

  toggleAccordion(data, index) {
    this.customFilterForm.reset();
    const redraw = -1;
    this.customFilterForm.patchValue(data.filter);
    this.openedIndex = this.openedIndex === index ? null : index;
    this.openedEditIndex = this.openedEditIndex === redraw ? null : redraw;
  }

  toggleEditAccordion(data, index) {
    const redraw = -1;
    this.customFilterForm.reset();
    this.customFilterForm.patchValue(data.filter);
    this.openedEditIndex = this.openedEditIndex === index ? null : index;
    this.openedIndex = this.openedIndex === redraw ? null : redraw;
  }

  // Update Custom Filter
  customFilterEdit(filter, index) {
    this.loader.create = true;
    const payload = {
      id: filter.id,
      ...this.customFilterForm.value,
    };
    this.filteredSource.emit({ action: "updateFilter", data: payload });
    // Close Toggle
     setTimeout(() => {
    this.openedEditIndex = null;
    this.loader.create = false;
    this.customFilterForm.reset();
  }, 2000);
  }

    cancelFilter() {
    this.openedEditIndex = null;
    this.customFilterForm.reset()
  }


  // Remove or Delete Custom Filter
  onCustomFilterDelete(filter) {
    const title = "Delete " + filter.name;
    this.gs.sweetAlertGeneralDelete(title, "Delete").then((res) => {
      if (res.value) {
        this.filteredSource.emit({ action: "deleteFilter", data: filter.id });
        this.customFilterForm.reset();
      }
    });
  }

  // On Daa Filter
  onDataFilter(filterKey, filterValue) {
    const data = {
      filterKey: filterKey,
      filterValue: filterValue,
    };
    this.filteredSource.emit({ action: "filter", data: data });
  }

  // Reset all filters
  resetFilters() {
    // Clear each checkbox in filterCheckBox
    for (let key in this.filterCheckBox) {
      this.filterCheckBox[key] = false;
    }
    this.filter.search = []; // clear search
    this.filter.minrange = [];
    this.filter.maxrange = [];
    this.filterCheckBox = {}; //Clear filterCheckBox
    this.filterRange = [];
    this.filterRadioBox = {}; //Clear filterRadioBox
    this.filterSelectBox = {}; //Clear filterSelectBox
    this.btn.create = "Create Filter";
  }

  // Clear and Reset all filters
  clearFilters() {
    this.resetFilters();
    this.btn.disabled = true;
    this.filteredSource.emit({ action: "clear", data: [] });
  }

  // remove self from modal service when component is destroyed
  ngOnDestroy(): void {
    // this.dataChanged.;
  }
}
